'use strict';

angular.module('TurneroApp').service('motivosService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Motivo/:id', { id: '@Id_Motivo' }, {
        get: {
            method: 'GET',
            params: {
                id_Motivo: '@id_Motivo'
            },
            url: portal.getUrlServer() + 'api/Motivo/GetInfo/',
        },
        GetByTipoMotivo: {
            method: 'GET',
            params: {
                id_tipo_motivo: 'id_tipo_motivo'
            },
            url: portal.getUrlServer() + 'api/Motivo/GetByTipoMotivo/:id_tipo_motivo/',
            isArray: true
        },
        getfiltro: {
            method: 'GET',
            withcredentials: true,
            params: {
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
                texto: '@texto'
            },
        },
        save: {
            method: 'POST',
        },
        'delete': {
            method: 'DELETE',
        },
        update: {
            method: 'PUT'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/motivos/motivosService.js